import { adjustColorLuminance } from './colorUtils'

export function applyStemTexture(graphics, baseColor, size, textureNoise = 0) {
  if (!graphics || !size) return

  const highlightColor = adjustColorLuminance(baseColor, 0.35)
  const shadowColor = adjustColorLuminance(baseColor, -0.35)

  const clampedSize = Math.max(2, size)
  const highlightWidth = Math.max(1, clampedSize * 0.4)
  const shadowWidth = Math.max(1, clampedSize * 0.45)
  const offset = (textureNoise - 0.5) * clampedSize * 0.2

  try {
    graphics.beginFill(highlightColor, 0.4)
    graphics.drawRect(
      -clampedSize / 2 + 0.8 + offset,
      -clampedSize / 2 + 0.6,
      highlightWidth,
      clampedSize * 0.45,
    )
    graphics.endFill()

    graphics.beginFill(shadowColor, 0.35)
    graphics.drawRect(
      clampedSize / 2 - shadowWidth - 0.8 + offset,
      -clampedSize / 2 + clampedSize * 0.35,
      shadowWidth,
      clampedSize * 0.55,
    )
    graphics.endFill()
  } catch (error) {
    // Texture overlay is purely cosmetic; ignore errors to avoid breaking rendering
    console.warn('applyStemTexture error:', error)
  }
}
